import { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import { Link } from "react-router-dom";
import useAuthUser from "../../../common/hooks/authUser";
import { withRouter } from "../../Common";

const ProfileMenu = () => {
    const [menu, setMenu] = useState(false);
    const { user } = useAuthUser();

    return (
        <Dropdown
            isOpen={menu}
            toggle={() => setMenu(!menu)}
            className="d-inline-block"
        >
            <DropdownToggle
                className="btn header-item "
                id="page-header-user-dropdown"
                tag="button"
            >
                <span className="d-none d-xl-inline-block ms-2 me-1">{user?.firstName} {user?.lastName}</span>
                <i className="mdi mdi-chevron-down d-none d-xl-inline-block"/>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
                <Link to="/profile" className="dropdown-item">
                    {" "}
                    <i className="bx bx-user font-size-16 align-middle me-1 text-primary"/>
                    Profile
                </Link>
                <div className="dropdown-divider"/>
                <Link to="/logout" className="dropdown-item">
                    <i className="bx bx-power-off font-size-16 align-middle me-1 text-primary"/>
                    <span>Logout</span>
                </Link>
            </DropdownMenu>
        </Dropdown>
    );
};

export default withRouter(ProfileMenu);
